import axios from "axios";


const API_BASE = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/knowledge` 
  : '/api/knowledge';

const getAuthToken = () => {
  // Try multiple possible keys where token might be stored
  let token = localStorage.getItem('token') || localStorage.getItem('accessToken');
  // Remove surrounding quotes if present (common when storing JSON string)
  if (token && token.startsWith('"') && token.endsWith('"')) {
    token = token.slice(1, -1);
    // Clean it in storage
    localStorage.setItem('token', token);
  }
  return token;
};

const authHeader = () => {
  const token = getAuthToken();
  console.log('[ChatBot] Token present:', !!token);
  return {
    headers: { Authorization: `Bearer ${token}` }
  };
};

export const knowledgeBaseService = {
  async getCategories() {
    try {
      const res = await axios.get(`${API_BASE}/categories`, authHeader());
      return res.data.categories;
    } catch (err) {
      console.error('Failed to fetch categories:', err);
      return [];
    }
  },

  async getSuggestedQuestions(category = 'all') {
    try {
      const res = await axios.get(`${API_BASE}/questions`, {
        params: { category },
        ...authHeader()
      });
      return res.data.questions;
    } catch (err) {
      console.error('Failed to fetch suggested questions:', err);
      return [];
    }
  },

  async query(question) {
    try {
      const res = await axios.post(`${API_BASE}/query`, { question }, authHeader());
      return res.data.answer;
    } catch (err) {
      console.error('Knowledge query failed:', err);
      return "I'm having trouble connecting. Please try again later.";
    }
  },

  async submitFeedback(messageId, isHelpful) {
    try {
      await axios.post(`${API_BASE}/feedback`, { messageId, isHelpful }, authHeader());
    } catch (err) {
      console.warn('Feedback submission failed:', err);
    }
  }
};